import React, { useEffect, useState } from "react";
import axios from "axios";
import "./styles/FeaturedIT.css";

function FeaturedInstitutesAndTeachers() {
  const [institutes, setInstitutes] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch top-rated institutes and teachers from the API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [institutesResponse, teachersResponse] = await Promise.all([
          axios.get("https://server.goatteachers.com/api/institutes/top-rated"),
          axios.get("https://server.goatteachers.com/api/teachers/top-rated"),
        ]);

        setInstitutes(institutesResponse.data);
        setTeachers(teachersResponse.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load data. Please try again later.");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Render loading state or error
  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <section className="featured-section">
      <div className="featured-container">
        {/* Featured Institutes */}
        <h3 className="asdfa">The Top Rankers</h3>
        <p className="asdfz">ইউজার রিভিউ দ্বারা র‍্যাংকড এবং পরিচালিত</p>

        <div className="slide-container">
          <div className="slide-track">
            {/* Duplicate the institutes for seamless looping */}
            {[...institutes, ...institutes].map((institute) => (
              <div key={institute.institute_id} className="slide-card">
                <h4>{institute.institute_name}</h4>
              </div>
            ))}
          </div>
        </div>

        {/* Featured Teachers */}
        <div className="slide-container">
          <div className="slide-track">
            {/* Duplicate the teachers for seamless looping */}
            {[...teachers, ...teachers].map((teacher) => (
              <div key={teacher.teacher_id} className="slide-card">
                <h4>{teacher.teacher_name}</h4>
                <p>{teacher.designation}</p>
                <p>{teacher.institute_name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeaturedInstitutesAndTeachers;
